import { definePreset, ThemeOptions } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

export const primePreset: ThemeOptions = definePreset(Aura, {
  semantic: {
    primary: {
      primary: {
        0: '#03619C',
        100: '#d4e6fa',
        200: '#8db9ec',
        300: '#46A8E1',
        400: '#007aff',
        500: '#03619C',
        600: '#03567A',
        700: '#02455A',
        800: '#013545',
        900: '#012132',
        950: '#011F2B',
      },
    },
    colorScheme: {
      light: {
        primary: {
          color: '#03619C',
          contrastColor: '#FFFFFF',
          hoverColor: '#1d92c4',
          activeColor: '#02455A',
        },
        surface: {
          ground: '#f3f6fb',
        },
      },
      dark: {
        primary: {
          color: '#007aff',
          contrastColor: '#FFFFFF',
          hoverColor: '#46A8E1',
          activeColor: '#8db9ec',
        },
        surface: {
          // Reworked to a navy-tinted scale (matching the login screen's
          // existing #12161f/#1e293b gradient) instead of Aura's default
          // neutral zinc, and deliberately keeps `ground` (the page
          // background) darker than surface.900 (cards/sidebar background)
          // so panels read as raised above the page, not sunken into it.
          400: '#94a3b8',
          500: '#64748b',
          600: '#475569',
          700: '#334155',
          800: '#1e293b',
          900: '#161e2c',
          950: '#0b1220',
          ground: '#0b1220',
          section: '#1e293b',
        },
      },
    },
  },
})
